// @flow
import type { AxiosPromise, AxiosInstance } from "axios";

const deleteUserVehicle = (
  vehicleId: string
): ((apiInstance: AxiosInstance) => AxiosPromise<>) => (apiInstance) => {
  return apiInstance.delete(`/v4/users/vehicles/${vehicleId}`);
};

export default deleteUserVehicle;
